import React from 'react'
import Button from '@blocks/Button'
import Flex from '@blocks/Flex'
import styled from 'styled-components'
import { colors } from '@styles/vars'

export default function Navigation({ children }: NavigationProps) {
    return (
        <Flex gap="8px" width="100%">
            {children}
        </Flex>
    )
}

Navigation.Item = NavigationItem

// COMPONENTS
function NavigationItem(props: INavigationButton): JSX.Element
function NavigationItem(props: INavigationLink): JSX.Element
function NavigationItem({ label, to, onClick, condition = true, active, icon, count, newTab }: INavigationItem) {
    if (!condition) return null
    return (
        <Button 
            type="tertiary" 
            scheme="transparent" 
            onClick={onClick} 
            icon={icon} 
            element={newTab ? "a" : undefined}
            isActive={active} 
            target={newTab ? "_blank" : undefined}
            to={to}>
            {label && <ButtonContainer>{label}{Boolean(count) && <CountContainer>{count}</CountContainer>}</ButtonContainer>}
        </Button>
    )
}

// STYLES
const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
`

const CountContainer = styled.small`
    background: ${colors.white};
    width: 24px;
    flex-shrink: 0;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${colors.black};
    border: 1px solid ${colors.border};
    margin-left: 8px;
`

// TYPES
interface INavigationItem {
    label?: string
    condition?: boolean
    to?: string
    onClick?(): void
    icon?: React.ReactNode
    active?: boolean
    count?: number
    newTab?: boolean
}

interface INavigationLink  {
    label?: string
    to: string
    condition?: boolean
    onClick?: never
    icon?: React.ReactNode
    active?: boolean
    count?: number
    newTab?: boolean
}

interface INavigationButton {
    label?: string
    onClick(): void
    condition?: boolean
    icon?: React.ReactNode
    active?: boolean
    to?: never
    count?: number
    newTab?: boolean
}

interface NavigationProps {
    children: React.ReactNode
}